// LIST
export const SUBSCRIPTION_LIST_REQUEST = "SUBSCRIPTION_LIST_REQUEST";
export const SUBSCRIPTION_LIST_SUCCESS = "SUBSCRIPTION_LIST_SUCCESS";
export const SUBSCRIPTION_LIST_FAIL = "SUBSCRIPTION_LIST_FAIL";

// CREATE
export const SUBSCRIPTION_CREATE_REQUEST = "SUBSCRIPTION_CREATE_REQUEST";
export const SUBSCRIPTION_CREATE_SUCCESS = "SUBSCRIPTION_CREATE_SUCCESS";
export const SUBSCRIPTION_CREATE_FAIL = "SUBSCRIPTION_CREATE_FAIL";
export const SUBSCRIPTION_CREATE_RESET = "SUBSCRIPTION_CREATE_RESET";

// UPDATE
export const SUBSCRIPTION_UPDATE_REQUEST = "SUBSCRIPTION_UPDATE_REQUEST";
export const SUBSCRIPTION_UPDATE_SUCCESS = "SUBSCRIPTION_UPDATE_SUCCESS";
export const SUBSCRIPTION_UPDATE_FAIL = "SUBSCRIPTION_UPDATE_FAIL";
export const SUBSCRIPTION_UPDATE_RESET = "SUBSCRIPTION_UPDATE_RESET";

// TOGGLE (Activate / Deactivate)
export const SUBSCRIPTION_TOGGLE_REQUEST = "SUBSCRIPTION_TOGGLE_REQUEST";
export const SUBSCRIPTION_TOGGLE_SUCCESS = "SUBSCRIPTION_TOGGLE_SUCCESS";
export const SUBSCRIPTION_TOGGLE_FAIL = "SUBSCRIPTION_TOGGLE_FAIL";

// 
export const SUBSCRIPTION_ORDER_REQUEST = "SUBSCRIPTION_ORDER_REQUEST";
export const SUBSCRIPTION_ORDER_SUCCESS = "SUBSCRIPTION_ORDER_SUCCESS";
export const SUBSCRIPTION_ORDER_FAIL = "SUBSCRIPTION_ORDER_FAIL";

export const SUBSCRIPTION_CONFIRM_REQUEST = "SUBSCRIPTION_CONFIRM_REQUEST";
export const SUBSCRIPTION_CONFIRM_SUCCESS = "SUBSCRIPTION_CONFIRM_SUCCESS";
export const SUBSCRIPTION_CONFIRM_FAIL = "SUBSCRIPTION_CONFIRM_FAIL";

export const SUBSCRIPTION_DELETE_REQUEST = "SUBSCRIPTION_DELETE_REQUEST";
export const SUBSCRIPTION_DELETE_SUCCESS = "SUBSCRIPTION_DELETE_SUCCESS";
export const SUBSCRIPTION_DELETE_FAIL = "SUBSCRIPTION_DELETE_FAIL";
export const SUBSCRIPTION_DELETE_RESET = "SUBSCRIPTION_DELETE_RESET";
